var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.formValidate.id ? "编辑用户等级" : "添加用户等级",
            visible: _vm.dialogVisible,
            width: "900px",
            "close-on-click-modal": false,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "userRef",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.formValidate,
                rules: _vm.rules,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "等级名称：", prop: "name" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: { maxlength: "10", placeholder: "请输入等级名称" },
                    model: {
                      value: _vm.formValidate.name,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formValidate,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "formValidate.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "等级级别：", prop: "grade" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择",
                        disabled: _vm.formValidate.grade === 0,
                      },
                      model: {
                        value: _vm.formValidate.grade,
                        callback: function ($$v) {
                          _vm.$set(_vm.formValidate, "grade", $$v)
                        },
                        expression: "formValidate.grade",
                      },
                    },
                    _vm._l(_vm.levelData, function (item) {
                      return _c("el-option", {
                        key: item.val,
                        attrs: {
                          label: item.name,
                          value: item.val,
                          disabled: item.disabled,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "所需成长值：", prop: "experience" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      disabled: _vm.formValidate.grade === 0,
                      placeholder: "请输入成长值",
                      min: 0,
                      max: 99999,
                      "step-strictly": "",
                    },
                    model: {
                      value: _vm.formValidate.experience,
                      callback: function ($$v) {
                        _vm.$set(_vm.formValidate, "experience", _vm._n($$v))
                      },
                      expression: "formValidate.experience",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "文字颜色：", prop: "backColor" } },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row" },
                    [
                      _c("el-color-picker", {
                        on: {
                          change: function ($event) {
                            return _vm.changeColor($event)
                          },
                        },
                        model: {
                          value: _vm.formValidate.backColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.formValidate, "backColor", $$v)
                          },
                          expression: "formValidate.backColor",
                        },
                      }),
                      _c("el-input", {
                        staticClass: "ml10 from-ipt-width",
                        attrs: { size: "small" },
                        model: {
                          value: _vm.formValidate.backColor,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formValidate,
                              "backColor",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "formValidate.backColor",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v("请输入文字颜色(例：#455A93)"),
                  ]),
                ]
              ),
              _c("el-form-item", { attrs: { label: "图标：", prop: "icon" } }, [
                _c(
                  "div",
                  {
                    staticClass: "upLoadPicBox",
                    on: {
                      click: function ($event) {
                        return _vm.modalPicTap(false, "icon")
                      },
                    },
                  },
                  [
                    _vm.formValidate.icon
                      ? _c("div", { staticClass: "pictrue" }, [
                          _c("img", { attrs: { src: _vm.formValidate.icon } }),
                        ])
                      : _c("div", { staticClass: "upLoad" }, [
                          _c("i", {
                            staticClass: "el-icon-camera cameraIconfont",
                          }),
                        ]),
                    _c("p", { staticClass: "desc mt10" }, [
                      _vm._v("尺寸：180*180px"),
                    ]),
                  ]
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "背景图：", prop: "backImage" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "upLoadPicBox",
                      on: {
                        click: function ($event) {
                          return _vm.modalPicTap(false, "backImage")
                        },
                      },
                    },
                    [
                      _vm.formValidate.backImage
                        ? _c("div", { staticClass: "pictrue" }, [
                            _c("img", {
                              attrs: { src: _vm.formValidate.backImage },
                            }),
                          ])
                        : _c("div", { staticClass: "upLoad" }, [
                            _c("i", {
                              staticClass: "el-icon-camera cameraIconfont",
                            }),
                          ]),
                    ]
                  ),
                  _c("p", { staticClass: "desc mt10" }, [
                    _vm._v("尺寸：660*300px"),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.resetForm("formValidate")
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: [
                        "platform:system:user:level:save",
                        "platform:system:user:level:update",
                      ],
                      expression:
                        "['platform:system:user:level:save', 'platform:system:user:level:update']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("formValidate")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }